/* Layout */
import Layout from '../views/admin/layout/Layout'

const asyncRouterMap = [
  /*   ========  ========  ======== */
  /*  ======== MY DIESEL ======== */
  /* ========  ========  ======== */
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'mydiesel', title: 'MyDiesel' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/profil_diesel'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['Owner'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/mydiesel/maklumatfleetcardsemasa_diesel'),
        meta: { title: 'Maklumat Fleet Card Semasa' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/mydiesel/permohonantambahkenderaan_diesel'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'tambahkenderaan',
        component: () => import('@/views/mydiesel/tambahkenderaan_diesel'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahkenderaan',
        component: () => import('@/views/mydiesel/mulatambahkenderaan_diesel'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/mydiesel/mulatambahsyarikatminyak_diesel'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'permohonantambahkenderaan-duplicate',
      //   component: () => import('@/views/mydiesel/permohonantambahkenderaan-duplicate'),
      //   meta: { title: 'DUPLICATE Permohonan Tambah Kenderaan' }
      // },
      // {
      //   path: 'testfile',
      //   component: () => import('@/views/mydiesel/testfile'),
      //   meta: { title: 'Testfile' }
      // },
      // {
      //   path: 'senaraifleetcard',
      //   component: () => import('@/views/mydiesel/senaraifleetcard_diesel'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/permohonanpertukaransyarikatminyak_diesel'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
      {
        path: 'tuntutan',
        component: () => import('@/views/mydiesel/tuntutan_diesel'),
        meta: { title: 'Tuntutan' },
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mydiesel/rayuan_diesel'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/mydiesel/keduatukarsyarikatminyak_diesel'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/tuntutan',
    component: Layout,
    redirect: '',
    name: 'Tuntutan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Tuntutan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/tuntutanadmin_diesel'),
        meta: { title: 'Tuntutan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'cawanganuser'], feature: 'mydiesel', title: 'Halaman Utama' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/dashboardduplicate_diesel2'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'mydiesel', title: 'Pengguna' },
    children: [
      // {
      //   path: 'senaraipengguna_all',
      //   component: () => import('@/views/mydiesel/senaraipengguna_all_diesel'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Awam [Semua]' }
      // },
      {
        path: 'senaraipengguna',
        component: () => import('@/views/mydiesel/senaraipengguna_diesel'),
        meta: { title: 'Pengguna Awam' }
      },
      {
        path: 'senaraikementerian',
        component: () => import('@/views/mydiesel/senaraikementerian_diesel'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Dalaman KPDN' }
      },
      // {
      //   path: 'senaraiagensi',
      //   component: () => import('@/views/mydiesel/senaraiagensi_diesel'),
      //   meta: { title: 'Pengguna Agensi' }
      // },
      {
        path: 'senaraisyarikatminyak',
        component: () => import('@/views/mydiesel/senaraisyarikatminyak_diesel'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Pengguna Syarikat Minyak' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mydiesel/pemegangakaun_diesel'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/mydiesel/physicalfleetcardadmin_diesel'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      // {
      //   path: 'kuota_tambahan',
      //   component: () => import('@/views/mydiesel/kuota_tambahan_diesel'),
      //   meta: { title: 'Kuota Tambahan' }
      // },
      // {
      //   path: 'pembatalan_kuota',
      //   component: () => import('@/views/mydiesel/pembatalan_kuota_diesel'),
      //   meta: { title: 'Pembatalan Kuota' }
      // },
      {
        path: 'pertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/pertukaransyarikatminyak_diesel'),
        meta: { title: 'Pertukaran Syarikat Minyak'},
      },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/mydiesel/fleetcardvehicleappeals_diesel'),
      //   meta: { title: 'Rayuan' }
      // },
      {
        // Old request/approval workflow — route kept reachable, hidden from the sidebar in favour
        // of the display-only list below.
        path: 'kuotatambahan',
        component: () => import('@/views/mydiesel/kuotatambahan_diesel'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Kuota Tambahan' },
        hidden: true
      },
      {
        path: 'senaraikuotatambahan',
        component: () => import('@/views/mydiesel/senaraikuotatambahan_diesel'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Kuota Tambahan' }
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/fleetcardvehicleappeals_diesel'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'menu_kuota_tambahan',
      //   component: () => import('@/views/mydiesel/halamanutama_diesel'),
      //   meta: { title: 'Tetapan Menu Kuota Tambahan' },
      // },
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/mydiesel/tetapanrekodpenggunaan_diesel'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/mydiesel/detailrekodpenggunaan_diesel'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_diesel'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      {
        path: 'senaraibanner',
        component: () => import('@/views/mydiesel/senaraibanner_diesel'),
        meta: { title: 'Senarai Banner' }
      },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/mydiesel/tetapanjenisbadan_diesel'),
        meta: { title: 'Tetapan Jenis Badan' },
      },
      {
        path: 'tetapanjenisbadanlog',
        component: () => import('@/views/mydiesel/vehiclebodymodellinkchange_diesel'),
        meta: { title: 'Log Tetapan Jenis Badan' },
        hidden: true,
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/mydiesel/tetapanjeniskegunaan_diesel'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/mydiesel/dashboardtetapanjenisbadan_diesel'),
        meta: { title: 'Tetapan Deskripsi Umum (Dashboard)' },
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/mydiesel/kandunganportal_diesel'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/mydiesel/kandunganbanner_diesel'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mypetrol/lparestrictions'),
        meta: { title: 'Senarai Sekatan' }
      },
      // {
      //   path: 'sejarahsekatan',
      //   component: () => import('@/views/mydiesel/sejarahsekatan_diesel'),
      //   meta: { title: 'Sejarah Sekatan' }
      // },
    ],
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/halamanutama_diesel'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mydiesel/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/mydiesel/halamanutama_diesel'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/search',
    component: Layout,
    redirect: '',
    name: 'Carian',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'mydiesel', title: 'Carian' },
    children: [
      {
        path: 'jpj',
        component: () => import('@/views/mypetrol/searchjpj_onlineinquiry_petrol'),
        meta: { title: 'Rekod Kenderaan' },
      },
      // {
      //   path: 'jpj_onlineinquiry',
      //   component: () => import('@/views/mypetrol/searchjpj_onlineinquiry_petrol'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Rekod Kenderaan Online Inquiry' },
      // },
      {
        path: 'ssm',
        component: () => import('@/views/mydiesel/searchssm_diesel'),
        meta: { title: 'Semakan Data Syarikat' },
      },
      {
        path: 'jpn',
        component: () => import('@/views/mydiesel/searchjpn_diesel'),
        meta: { relationRoles: ['kpdnadmin'], title: 'Semakan Data Pemilikan Tunggal' },
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/laporan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'mydiesel', title: 'Laporan' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/laporan_diesel'),
        meta: { title: 'Laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/kpdnprofil',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'mydiesel', title: 'Profil' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/kpdnprofil_diesel'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/systemsettingsnextlevel',
    component: Layout,
    redirect: '',
    name: 'Tetapan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Tetapan Sistem' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/systemsettings_diesel'),
        meta: { title: 'Tetapan Sistem' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/vehicleownershipchanges',
    component: Layout,
    redirect: '',
    name: 'Log Tukar Hak Milik',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Log Tukar Hak Milik' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/vehicleownershipchange_diesel'),
        meta: { title: 'Log Tukar Hak Milik' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/vehiclebodytypechanges',
    component: Layout,
    redirect: '',
    name: 'Log Tukar Body Type',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Log Tukar Body Type' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/vehiclebodytypechange_diesel'),
        meta: { title: 'Log Tukar Body Type' },
        hidden: true
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/manual',
    component: Layout,
    redirect: '',
    name: 'Manual',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'mydiesel', title: 'Manual' },
    children: [
      {
        path: 'manualpegawai',
        component: () => import('@/views/mydiesel/blank_diesel'),
        meta: { title: 'Manual Pegawai' },
      },
      {
        path: 'manualpengguna',
        component: () => import('@/views/mydiesel/blank_diesel'),
        meta: { title: 'Manual Pengguna' },
      },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/testing',
  //   component: Layout,
  //   redirect: '',
  //   name: 'TESTING',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'TESTING' },
  //   children: [
  //     {
  //       path: 'testingssmcompanies',
  //       component: () => import('@/views/mydiesel/testingssmcompanies_diesel'),
  //       meta: { title: 'SSM Companies' },
  //     },
  //     {
  //       path: 'testingjpjcompanies',
  //       component: () => import('@/views/mydiesel/testingjpjcompanies_diesel'),
  //       meta: { title: 'JPJ Companies' },
  //     },
  //     {
  //       path: 'testingjpjvehicles',
  //       component: () => import('@/views/mydiesel/testingjpjvehicles_diesel'),
  //       meta: { title: 'JPJ Vehicles' },
  //     },
  //     {
  //       path: 'testingmyidentityindividuals',
  //       component: () => import('@/views/mydiesel/testingmyidentityindividuals_diesel'),
  //       meta: { title: 'myIDENTITY Individuals' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'MyDiesel' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/halamanutamaoilcompany_diesel'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Halaman Utama',
    meta: { relationRoles: ['unregistereduser'], feature: 'mydiesel', title: 'Halaman Utama' },
    children: [
      {
        path: '',
        component: () => import('@/views/mydiesel/halamanutamaunregistered_diesel'),
        meta: { title: 'Halaman Utama' },
        // hidden: true
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/mydiesel/pemegangakaunoilcompany_diesel'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'physicalfleetcard',
      //   component: () => import('@/views/mydiesel/physicalfleetcardoilcompany_diesel'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      {
        path: 'permohonanpertukaransyarikatminyak',
        component: () => import('@/views/mydiesel/permohonanpertukaransyarikatminyakoilcompany_diesel'),
        meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/rekodpenggunaan',
    component: Layout,
    redirect: '',
    name: 'Laporan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Laporan' },
    children: [
      // {
      //   path: 'rekodpenggunaan',
      //   component: () => import('@/views/mydiesel/rekodpenggunaanoilcompany'),
      //   meta: { title: 'Rekod Penggunaan' }
      // },
      {
        path: 'detailrekodpenggunaanoilcompany',
        component: () => import('@/views/mydiesel/detailrekodpenggunaanoilcompany_uploadversion'),
        meta: { title: 'Laporan Penggunaan Kuota' }
      },
      {
        path: 'detailmonthquotaoilcompany',
        component: () => import('@/views/mydiesel/detailmonthquotaoilcompany_diesel'),
        meta: { title: 'Laporan Pemegang Akaun' }
      },
      {
        path: 'kuotatambahan',
        component: () => import('@/views/mydiesel/kuotatambahanoilcompany_diesel'),
        meta: { title: 'Laporan Kuota Tambahan' },
        hidden: true
      },
      // {
      //   path: 'percentagechangesoilcompany',
      //   component: () => import('@/views/mydiesel/percentagechangesoilcompany'),
      //   meta: { title: 'Laporan Perubahan Kuota' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mydiesel/senaraisekatanoilcompany_diesel'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mydiesel/banner',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Senarai Banner',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'Banner' },
  //   children: [
  //     {
  //       path: 'senaraibanner',
  //       component: () => import('@/views/mydiesel/senaraibanner_diesel'),
  //       meta: { title: 'Senarai Banner' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mydiesel/lpagenerator',
    component: Layout,
    redirect: '',
    name: 'LPA Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'LPA Generator' },
    children: [
      {
        path: 'lpagenerator',
        component: () => import('@/views/mydiesel/lpagenerator_diesel'),
        meta: { title: 'LPA Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/lpageneratorsapphire',
    component: Layout,
    redirect: '',
    name: 'LPA Generator Sapphire Diesel',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'LPA Generator Sapphire' },
    children: [
      {
        path: 'lpageneratorsapphire',
        component: () => import('@/views/mydiesel/lpagenerator_diesel_sapphire'),
        meta: { title: 'LPA Generator Sapphire' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/lpageneratorruby',
    component: Layout,
    redirect: '',
    name: 'LPA Generator Ruby Diesel',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'LPA Generator Ruby' },
    children: [
      {
        path: 'lpageneratorruby',
        component: () => import('@/views/mydiesel/lpagenerator_diesel_ruby'),
        meta: { title: 'LPA Generator Ruby' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/lpadownload',
    component: Layout,
    redirect: '',
    name: 'LPA Download',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'mydiesel', title: 'LPA Download' },
    children: [
      {
        path: 'lpadownload',
        component: () => import('@/views/mydiesel/lpadownload_diesel'),
        meta: { title: 'LPA Download' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/lpageneratornew',
    component: Layout,
    redirect: '',
    name: 'LPA Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'LPA Generator' },
    children: [
      {
        path: 'lpageneratornew',
        component: () => import('@/views/mydiesel/lpageneratornew_diesel'),
        meta: { title: 'LPA Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/mofgenerator',
    component: Layout,
    redirect: '',
    name: 'LPA Generator',
    meta: { relationRoles: ['kpdnadmin'], feature: 'mydiesel', title: 'LPA Generator' },
    children: [
      {
        path: 'mofgenerator',
        component: () => import('@/views/mydiesel/mofgenerator_diesel'),
        meta: { title: 'LPA Generator' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mydiesel/sekatan',
    component: Layout,
    redirect: '',
    name: 'Sekatan',
    meta: { relationRoles: ['enforcer'], feature: 'mydiesel', title: 'Sekatan' },
    children: [
      {
        path: 'senaraisekatan',
        component: () => import('@/views/mydiesel/senaraisekatanpenguatkuasa_diesel'),
        meta: { title: 'Senarai Sekatan' }
      },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true
  }
]

export default asyncRouterMap


// WEBPACK FOOTER //
// ./src/router/mydiesel.js